import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pt-6 text-center"},[_c(VIcon,{attrs:{"color":"errorred","x-large":""}},[_vm._v("far fa-trash-alt")]),_vm._v(" "),_c('h4',{staticClass:"primary--text mt-12"},[_vm._v(_vm._s(_vm.$t('INTEGRATIONS.MICROSOFTTEAMS.DELETE_TAB')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }